import React from 'react';
import dh from '../../../helpers/date.helper';

const dateDataCell = ({ attr }) => ({ item: { [attr]: date } }) => (
  <span className="fs-90">{dh.getFormattedDate(date)}</span>
);

export default dateDataCell;



// WEBPACK FOOTER //
// ./src/components/cms/gridComponents/dateDataCell.js